module.exports = __webpack_public_path__ + "static/laura_2-54f59df97fcaf9d2eb044789d758d9cc.jpg";